import reducer from "./reducers";

export { default as pastOrdersOperations } from "./operations";

export default reducer
